import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
    },
    {
        path: '/merchant-search',
        name: 'MerchantSearch',
        component: () => import('../views/MerchantSearch.vue'),
    },
    {
        path: '/status',
        name: 'Status',
        component: () => import('../views/StatusQuery.vue'),
        meta: { requiresAuth: true, roles: ['customer', 'admin', 'subscriber'] },
    },
    {
        path: '/status/:rmaNumber',
        name: 'StatusDetail',
        component: () => import('../views/StatusDetail.vue'),
        meta: { requiresAuth: true, roles: ['customer', 'admin', 'subscriber'] },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
    },
    {
        path: '/subscriber',
        name: 'Subscriber',
        component: () => import('../views/subscriber/Dashboard.vue'),
        meta: { requiresAuth: true, roles: ['subscriber'] },
    },
    {
        path: '/subscriber/requests',
        name: 'SubscriberRequests',
        component: () => import('../views/subscriber/RequestList.vue'),
        meta: { requiresAuth: true, roles: ['subscriber'] },
    },
    {
        path: '/subscriber/requests/:id',
        name: 'SubscriberRequestDetail',
        component: () => import('../views/subscriber/RequestDetail.vue'),
        meta: { requiresAuth: true, roles: ['subscriber'] },
    },
    {
        path: '/subscriber/merchant-policy',
        name: 'MerchantPolicy',
        component: () => import('../views/MerchantPolicy.vue'),
        meta: { requiresAuth: true, roles: ['subscriber', 'admin'] },
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('../views/admin/Dashboard.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/admin/requests',
        name: 'AdminRequests',
        component: () => import('../views/admin/RequestList.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/admin/requests/:id',
        name: 'AdminRequestDetail',
        component: () => import('../views/admin/RequestDetail.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/admin/technician',
        name: 'AdminTechnician',
        component: () => import('../views/admin/TechnicianView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/admin/quickbooks',
        name: 'AdminQuickBooks',
        component: () => import('../views/admin/QuickBooksSettings.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/admin/b2b-clients',
        name: 'AdminB2BClients',
        component: () => import('../views/admin/B2BClients.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/b2b',
        name: 'B2BPortal',
        component: () => import('../views/B2BPortal.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/format',
        name: 'Format',
        component: () => import('../views/FormatSettings.vue'),
        meta: { requiresAuth: true, roles: ['admin', 'subscriber'] },
    },
    {
        path: '/policy-engine',
        name: 'PolicyEngine',
        component: () => import('../views/PolicyEngine.vue'),
        meta: { requiresAuth: true, roles: ['subscriber', 'admin'] },
    },
    {
        path: '/signup',
        name: 'Signup',
        component: () => import('../views/Signup.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
    },
    {
        path: '/verify-email',
        name: 'VerifyEmail',
        component: () => import('../views/VerifyEmail.vue'),
    },
    {
        path: '/request',
        name: 'RequestRMA',
        component: () => import('../views/RequestRMA.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/send-email',
        name: 'EmailVerification',
        component: () => import('../views/EmailVerification.vue'),
    },
    {
        path: '/credential',
        name: 'Credential',
        component: () => import('../views/Credential.vue'),
        meta: { requiresAuth: true, roles: ['subscriber'] },
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const isAuthenticated = store.getters.isAuthenticated || localStorage.getItem('token');
    const user = store.getters.user || {};
    const userRole = user.role || null;
    const allowedRoles = to.meta.roles || [];
    const requiresEmail = to.matched.some((record) => record.meta.requiresEmail);
    const isEmailVerified = store.getters.isEmailVerified;
    if (requiresEmail && !isEmailVerified) {
        return next('/send-email');
    }
    // Not logged in
    if (requiresAuth && !isAuthenticated) {
        return next('/login');
    }
    // Logged in but visiting /login again → redirect to correct dashboard
    if (to.name === 'Login' && isAuthenticated) {
        if (userRole === 'admin')
            return next('/admin');
        if (userRole === 'subscriber')
            return next('/subscriber');
        return next('/request');
    }
    // Auto-redirect from /request if email not verified
    if (to.path === '/request' && !isEmailVerified) {
        return next('/send-email');
    }
    // Role not allowed — only enforce if user is actually loaded (role known)
    if (allowedRoles.length > 0 && userRole && !allowedRoles.includes(userRole)) {
        if (userRole === 'admin')
            return next('/admin');
        if (userRole === 'subscriber')
            return next('/subscriber');
        return next('/request');
    }
    next();
});
export default router;
